import Typography from "@/elements/Typography";
import Box from "@/elements/Box";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <Box p={2}>
      <Box
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h4" mr={2}>
          {t("notFound.titolo")}
        </Typography>
      </Box>
    </Box>
  );
}
